// extracted by mini-css-extract-plugin
export default {"banner_text":"drop-zone_banner_text__ywip8","banner":"drop-zone_banner__OTkGo","input":"drop-zone_input__GQ2VA"};